// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, css, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, state } from 'lit/decorators.js';
import LightElement from './light-element.js';
import Helpers from '../../typescript/modules/helpers.js';

@customElement('product-comparison-toggle')
export default class ProductComparisonToggle extends LightElement {

	@state()
	isComparingMode: boolean = false;

	connectedCallback() {
		super.connectedCallback();
		this.updateComparingMode();
	}

	updateComparingMode() {
		const comparingMode = localStorage.getItem('comparingMode');
		this.isComparingMode = comparingMode === 'true' && !document.querySelector('btu-calculator'); // Disable comparing mode if BTU calculator is present
		this.updateDocumentClass();
	}

	setComparingMode(event: Event) {
		this.isComparingMode = (event.target as HTMLInputElement).checked;
		localStorage.setItem('comparingMode', this.isComparingMode.toString());
		const setComparingModeEvent = Helpers.createCustomEventForDispatch('productComparisonMode', { mode: this.isComparingMode.toString() });
		document.dispatchEvent(setComparingModeEvent);
		this.updateDocumentClass();
	}

	updateDocumentClass() {
		if (this.isComparingMode) {
			document.documentElement.classList.add('comparing-mode');
		} else {
			document.documentElement.classList.remove('comparing-mode');
		}
	}

	render() {
		return html`
		<div class="c-product-comparison-toggle">
			<label class="c-toggle">
				<span class="c-toggle__label">
					Compare
				</span>
				<input
					type="checkbox"
					class="c-toggle__input"
					.checked="${this.isComparingMode}"
					@change="${this.setComparingMode}"
				/>
				<span class="c-toggle__slider" data-test="comparison-toggle-button"></span>
			</label>
		</div>
		`;
	}
}
